/**
 * Spinner animado con el logo de OneFIN para indicar carga en pantalla.
 */
import React from "react";
import { LoadingOutlined } from "@ant-design/icons";

const SpinOneFIN = () => {
  return (
    <div style={{ animation: "breathing 1.5s ease-in-out infinite" }}>
      <LoadingOutlined style={{ fontSize: 24, color: "#791ea3" }} spin />
    </div>
  );
};

export default SpinOneFIN;
